import { render, staticRenderFns } from "./workoutsDashboardSearchAndCreate.vue?vue&type=template&id=1737637b&scoped=true"
import script from "./workoutsDashboardSearchAndCreate.vue?vue&type=script&lang=js"
export * from "./workoutsDashboardSearchAndCreate.vue?vue&type=script&lang=js"
import style0 from "./workoutsDashboardSearchAndCreate.vue?vue&type=style&index=0&id=1737637b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1737637b",
  null
  
)

export default component.exports